import React from 'react';

import { Login } from '../index';

export const TokenLogin: React.FC = () => <Login tokenOnly />;
